var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout"},[_c('Navigation'),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }